import { Injectable } from '@angular/core';
import { ApiCommon } from '@shared/apis/common';
import { Observable } from 'rxjs';
import { ParamsBuilder } from '@shared/models/params-builder';

@Injectable({
  providedIn: 'root'
})
export class ZipCodeApi extends ApiCommon {

  getZipCodes(pageEvent, q?: any, query?: any): Observable<any> {
    const builder = new ParamsBuilder();
    builder.pageEvent = pageEvent;

    if (q && JSON.stringify(q) !== '{}') {
      builder.q = q;
    }

    if (query) {
      builder.query = query;
    }

    return this.apiServer.zipCode.getZipCodes(builder.build());
  }

  getZipCode(zipCode): Observable<any> {
    return this.apiServer.zipCode.getZipCode(zipCode);
  }

  saveZipCode(zipCodeDate): Observable<any> {
    return this.apiServer.zipCode.saveZipCode(zipCodeDate);
  }
}
